"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'password.reset.hero.title': '¿Olvidaste tu contraseña?',
    'password.reset.hero.description': 'No te preocupes, le pasa a todo el mundo. Ingresa tu dirección de correo electrónico y te enviaremos un enlace para restablecer tu contraseña.',
    'password.reset.hero.login_link_text': '¿Recuerdas tu contraseña?',
    'password.reset.hero.login_link': 'Inicia sesión aquí',
    'password.reset.page.title': 'Restablecer Contraseña',
    'password.reset.form.title': 'Restablecer tu Contraseña',
    'password.reset.confirm.hero.title': 'Establecer Nueva Contraseña',
    'password.reset.confirm.hero.description': 'Crea una contraseña fuerte que puedas recordar. Tu nueva contraseña debe ser diferente de la anterior.',
    'password.reset.confirm.hero.login_link_text': '¿Recuerdas tu contraseña?',
    'password.reset.confirm.hero.login_link': 'Inicia sesión aquí',
    'password.reset.confirm.page.title': 'Establecer Nueva Contraseña',
    'password.reset.confirm.form.title': 'Crear Nueva Contraseña',
    'password.reset.title': 'Restablecer Contraseña',
    'password.reset.description': 'Ingresa tu dirección de correo electrónico y te enviaremos un enlace para restablecer tu contraseña.',
    'password.reset.email.label': 'Dirección de Correo Electrónico',
    'password.reset.email.placeholder': 'Ingresa tu dirección de correo electrónico',
    'password.reset.submit': 'Enviar Enlace',
    'password.reset.backToLogin': 'Volver al Inicio de Sesión',
    'password.reset.failed': 'Error al enviar el correo de restablecimiento',
    'password.reset.sent': 'Correo de restablecimiento de contraseña enviado exitosamente',
    'password.reset.success.title': '¡Correo Enviado!',
    'password.reset.success.description': 'Revisa tu correo electrónico para instrucciones sobre cómo restablecer tu contraseña.',
    'password.reset.confirm.title': 'Establecer Nueva Contraseña',
    'password.reset.confirm.description': 'Ingresa tu nueva contraseña abajo.',
    'password.reset.confirm.password.label': 'Nueva Contraseña',
    'password.reset.confirm.password.placeholder': 'Ingresa nueva contraseña',
    'password.reset.confirm.confirmPassword.label': 'Confirmar Contraseña',
    'password.reset.confirm.confirmPassword.placeholder': 'Confirma nueva contraseña',
    'password.reset.confirm.submit': 'Restablecer Contraseña',
    'password.reset.confirm.failed': 'Error al restablecer la contraseña',
    'password.reset.confirm.success': 'Contraseña restablecida exitosamente',
    'password.reset.confirm.success.title': '¡Contraseña Restablecida!',
    'password.reset.confirm.success.description': 'Tu contraseña ha sido restablecida exitosamente. Ahora puedes iniciar sesión con tu nueva contraseña.',
    'password.reset.confirm.mismatch': 'Las contraseñas no coinciden',
    'password.reset.confirm.length': 'La contraseña debe tener al menos 6 caracteres',
};
